import { api } from '.'

export const lkApi = api.injectEndpoints({
  endpoints: build => ({
    products: build.query({
      query: () => ({
        url: `/mega_cards/lk-products/`,
        method: 'GET'
      })
    }),
    verifyOrder: build.mutation({
      query: ({ code }) => ({
        url: `/mega_cards/products/lk-verify-order/`,
        method: 'POST',
        body: { code }
      })
    }),
    transactions: build.query({
      query: ({ uuid, date_from, date_to }) => ({
        url: `/mega_cards/${uuid}/transactions/${date_from}/${date_to}/`,
        method: 'GET'
      })
    }),
    sendSms: build.mutation({
      query: ({ uuid }) => ({
        url: `/mega_cards/${uuid}/send-sms/`,
        method: 'POST',
        body: { uuid }
      })
    }),
    lkOrder: build.mutation({
      query: ({ product_code }) => ({
        url: `/mega_cards/products/lk-order/`,
        method: 'POST',
        body: { product_code }
      })
    }),
    lkVerifyOrder: build.mutation({
      query: ({ code }) => ({
        url: `/mega_cards/products/lk-verify-order/`,
        method: 'POST',
        body: { code }
      })
    })
  })
})

export const {
  useProductsQuery,
  useTransactionsQuery,
  useVerifyOrderMutation,
  useSendSmsMutation,
  useLkOrderMutation,
  useLkVerifyOrderMutation
} = lkApi
